<template>
  <div class="content d-flex">
    <ManageSidebar></ManageSidebar>
    <section :style="{ width: '100%' }">
      <div class="mt-1 title-section">
        <v-btn
          class="ma-1"
          variant="text"
          elevation="false"
          color="transparent"
          min-width="0"
          @click="goBack()"
          ><svg
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M11 1L2 9.5L11 18.5" stroke="black" stroke-width="2" />
          </svg>
        </v-btn>
        <h1>Partner History</h1>
      </div>
      <v-overlay :opacity="0.5" :value="isLoading">
        <v-progress-circular indeterminate size="64">
          Loading...
        </v-progress-circular>
      </v-overlay>
      <div class="mt-8">
        <div
          v-for="record in getPageView(page)"
          :key="record._id"
          class="mb-1 pa-1"
        >
          <div v-if="record.yearGap" class="mb-8">
            <h1 :style="{ 'margin-bottom': 0 }">{{ record.yearGap }}</h1>
            <v-divider></v-divider>
          </div>
          <div class="record-row">
            <span class="black-ellipse"></span
            ><span class="record-datetime">{{
              formatDate(new Date(record.createdAt))
            }}</span>
            <span class="record-content">{{ renderContent(record) }}</span>
          </div>
        </div>
      </div>
      <div class="mt-8">
        <template>
          <div class="text-center">
            <v-container>
              <v-row justify="center">
                <v-col cols="8">
                  <v-container class="max-width">
                    <v-pagination
                      v-model="page"
                      :length="getLocalLastPage()"
                      ellipsis="•••"
                      class="my-4"
                    ></v-pagination>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import constants from 'august-constants';
import _ from 'lodash';

import config from '../config';
import util from '../util';
import ManageSidebar from '../components/ManageSidebar.vue';

export default {
  name: 'OperationHistory',
  components: {
    ManageSidebar,
  },
  data: () => {
    return {
      constants,
      records: [],
      page: 1,
      lastPage: 9999,
      nextPos: '',
      end: false,
      viewPageSize: 15,
      isLoading: false,
    };
  },
  created: async function () {
    const partnerID = this.$route.params.partnerID;
    await this.loadNextPage(`partnerID=${partnerID}`);
  },
  methods: {
    loadNextPage: async function (pos = '') {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const options = {
        method: 'GET',
        ...config.defaultFetchOptions,
      };
      try {
        const resposne = await util.fetch(
          `${this.$store.state.apiHost}/audit/history?${pos}`,
          options
        );

        if (resposne.ok) {
          const pageResult = await resposne.json();
          this.records = [...this.records, ...pageResult.result];
          this.nextPos = pageResult.nextPos;
          this.end = pageResult.end;
          if (this.end) {
            this.lastPage = this.getLocalLastPage();
          }
        } else {
          this.$store.commit('snackbar', {
            text: 'Failed to get records.',
            color: 'error',
          });
        }
      } catch (error) {
        this.$store.commit('snackbar', {
          text: 'Failed to get records.',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    getLocalLastPage() {
      const i = Math.floor(this.records.length / this.viewPageSize);
      const r = this.records.length - i * this.viewPageSize;
      return r > 0 ? i + 1 : i;
    },

    formatDate(date) {
      const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];

      const month = monthNames[date.getMonth()];
      const day = date.getDate().toString().padStart(2, '0'); // Add leading zero if needed
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${month}.${day} ${hours}:${minutes}`;
    },

    getPageView(i) {
      if (_.isEmpty(this.records)) {
        return [];
      }
      if (i === this.getLocalLastPage() && !this.isLoading && !this.end) {
        this.loadNextPage(this.nextPos);
      }
      const startIndex = _.max([0, (i - 1) * this.viewPageSize]);
      const endIndex = _.min([i * this.viewPageSize, this.records.length]);
      const slice = _.slice(this.records, startIndex, endIndex);

      let currentYear = new Date().getFullYear();
      return slice.map((item) => {
        const year = new Date(item.createdAt).getFullYear();
        if (year < currentYear) {
          currentYear = year;

          return { ...item, yearGap: year };
        }

        return item;
      });
    },

    renderContent(record) {
      const formatField = (field) => {
        return {
          redirectUris: 'redirect URLs'
        }[field] ?? field
      };

      const getDiffKeyNames = (eventData) => {
        return _.filter(Object.keys(eventData), (key) => {
          return (
            !_.includes(
              ['_id', 'id', 'oldName', 'partnerID', 'partnerName', 'credentialID'],
              key
            ) && !key.startsWith('calling')
          );
        })
          .map((key) => {
            if (key === 'status') {
              return `status to ${_.toUpper(eventData['status'])}`;
            } else {
              return formatField(key);
            }
          })
          .join(', ');
      };

      const toRoleName = (e) => {
        switch(e) {
        case constants.DeveloperRoles.GLOBAL_ADMIN:
          return 'Global Admin';
        case constants.DeveloperRoles.PARTNER_ADMIN:
          return 'Partner Admin';
        case constants.DeveloperRoles.PARTNER_READER:
          return 'Partner Reader';
        default:
          break;
        }
      };

      const displayName = record.eventData.oldName ?? record.eventData.name;
      if (
        record.eventData.callingUserRole ===
        constants.DeveloperRoles.PARTNER_ADMIN
      ) {
        record.eventData.partnerID = record.partnerID;
      }
      switch (record.eventName) {
        case constants.DeveloperAuditEvents.CREATE_PARTNER:
          return `${record.eventData.callingUserName} created partner ${displayName}`;
        case constants.DeveloperAuditEvents.DELETE_PARTNER:
          return `${record.eventData.callingUserName} deleted partner ${displayName}`;
        case constants.DeveloperAuditEvents.EDIT_PARTNER:
          return `${
            record.eventData.callingUserName
          } changed partner ${displayName}'s ${getDiffKeyNames(
            record.eventData
          )}`;
        case constants.DeveloperAuditEvents.ENABLE_PARTNER:
          return `${record.eventData.callingUserName} enabled partner ${record.eventData.partnerName}`;
        case constants.DeveloperAuditEvents.DISABLE_PARTNER:
          return `${record.eventData.callingUserName} disabled partner ${record.eventData.partnerName}`;
        case constants.DeveloperAuditEvents.INVITE_USER:
          return `${record.eventData.callingUserName} invited user ${displayName} as role ${toRoleName(record.eventData.role)}`;
        case constants.DeveloperAuditEvents.EDIT_USER:
          return `${
            record.eventData.callingUserName
          } changed user ${displayName} ${getDiffKeyNames(record.eventData)}`;
        case constants.DeveloperAuditEvents.DELETE_USER:
          return `${record.eventData.callingUserName} deleted user ${displayName}`;
        case constants.DeveloperAuditEvents.CREATE_CREDENTIAL:
          return `${record.eventData.callingUserName} created credential ${displayName} to partner ${record.eventData.partnerName}`;
        case constants.DeveloperAuditEvents.DELETE_CREDENTIAL:
          return `${record.eventData.callingUserName} removed credential ${displayName} from partner ${record.eventData.partnerName}`;
        case constants.DeveloperAuditEvents.EDIT_CREDENTIAL:
          return `${
            record.eventData.callingUserName
          } changed credential ${displayName}'s ${getDiffKeyNames(
            record.eventData
          )}`;
        case constants.DeveloperAuditEvents.EXTEND_CREDENTIAL_LIFE:
          return `${record.eventData.callingUserName} extend 30 days life for credential ${displayName}`;
        case constants.DeveloperAuditEvents.ENABLE_PII_ACCESS:
          return `${record.eventData.callingUserName} enable Pii Data`;
        case constants.DeveloperAuditEvents.DISABLE_PII_ACCESS:
          return `${record.eventData.callingUserName} disable Pii Data`;
        default:
          return 'Unknown event';
      }
    },
  },
};
</script>

<style lang="scss">
.content.has-side-nav {
  padding-left: 0;

  .side-nav {
    min-width: 11rem;
    padding: 0 1rem;
    border-right: 1px solid #cccccc;
    margin-right: 4rem;

    .side-nav-links {
      list-style-type: none;
      padding-left: 0;

      li {
        padding-bottom: 0.5rem;
        border-bottom: 2px solid #eeeeee;
        margin-bottom: 0.5rem;
      }
    }
  }
}

.select {
  max-width: 10rem;
}

div .record-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.record-datetime {
  width: 120px;
  color: #a0a0a0;
}

.record-content {
  margin-right: 0px;
}

.black-ellipse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: black;
  margin-right: 12px;
}

.small-black-ellipse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: black;
  margin-right: 12px;
}

.title-section {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  margin-left: -48px;
}

.title-section > h1 {
  margin-bottom: 0;
}
</style>
